import { useContext } from "react";
import { GlobalPreferencesContext, GlobalPreferencesDispatchContext } from ".";
import {
  ListViewGlobalValues,
  PreferenceGroup,
  PreferenceKeyImpl,
} from "@services/userPreferences/types";

export const useGlobalListPreferences = (): [
  ListViewGlobalValues,
  (data: Partial<ListViewGlobalValues>) => void
] => {
  const context = useContext(GlobalPreferencesContext);
  const dispatchContext = useContext(GlobalPreferencesDispatchContext);
  const data = context.list_view.global;

  const dispatch = (data: Partial<ListViewGlobalValues>) =>
    dispatchContext.update<ListViewGlobalValues>(
      PreferenceGroup.LIST_VIEW,
      PreferenceKeyImpl.global,
      data
    );
  return [data, dispatch];
};
